import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { catchError, map, Observable, of } from "rxjs";
import { UsersService } from "@app/services/users/users.service";
import { AuthService } from "@app/services/auth/auth-service.service";

@Injectable({
  providedIn: "root",
})
export class UpdateInfoGuard implements CanActivate {
  constructor(
    private userService: UsersService,
    private router: Router,
    private _auth: AuthService
  ) {}

  canActivate(): Observable<boolean> | boolean {
    if (this.userService.getToken()) {
      return this.userService.fetchUser().pipe(
        map(data => {
          const { user } = data;

          if (user.update_data) {
            this.router.navigate(["/home"]);
            return false;
          }

          return true;
        }),
        catchError(() => {
          this._auth.logout();
          return of(false);
        })
      );
    }

    this.router.navigate(["/login"]);
    return false;
  }
}
